import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderExportNavModule } from './extensions/4dce072cc1558b65db2996baf05b10471e4d2ea364f5b5572aeebb7afbde8c5b/order-export-nav.module';
import { InvoicesNavModule } from './extensions/a9dcc808ddd51c6be0b70eaa57664f2f98b556a7e935815f2c1fc5a2061191cf/invoices-nav.module';

import SharedProviders_1_0 from './extensions/blogs-ui/providers';
import SharedProviders_2_0 from './extensions/page/providers';
import SharedProviders_3_0 from './extensions/ncm-plugin/providers';
import SharedProviders_4_0 from './extensions/a9dcc808ddd51c6be0b70eaa57664f2f98b556a7e935815f2c1fc5a2061191cf/providers';
import SharedProviders_5_0 from './extensions/fulfillment-scan-ui/providers';
import SharedProviders_6_0 from './extensions/seller-registration-ui/providers';
import SharedProviders_7_0 from './extensions/banners/providers';
import SharedProviders_8_0 from './extensions/newsletter-ui/providers';
import SharedProviders_9_0 from './extensions/loyalty-points-ui/providers';
import SharedProviders_10_0 from './extensions/admin-roles-ui/providers';
import SharedProviders_11_0 from './extensions/0b4a1bcd0444ede227729459acd16554405c57ff6a9c7c31d062aa88ae4e851e/providers';
import SharedProviders_12_0 from './extensions/barcode-ui/providers';
import SharedProviders_13_0 from './extensions/price-bidding-ui/providers';
import SharedProviders_14_0 from './extensions/dbe409e77e3c92803dca4423de25324d59a57ac068bd86bbf7dd65b13d96482a/providers';
import SharedProviders_15_0 from './extensions/business-account-ui/providers';
import SharedProviders_16_0 from './extensions/contact-ui/providers';


@NgModule({
    imports: [CommonModule, OrderExportNavModule, InvoicesNavModule],
    providers: [...SharedProviders_1_0, ...SharedProviders_2_0, ...SharedProviders_3_0, ...SharedProviders_4_0, ...SharedProviders_5_0, ...SharedProviders_6_0, ...SharedProviders_7_0, ...SharedProviders_8_0, ...SharedProviders_9_0, ...SharedProviders_10_0, ...SharedProviders_11_0, ...SharedProviders_12_0, ...SharedProviders_13_0, ...SharedProviders_14_0, ...SharedProviders_15_0, ...SharedProviders_16_0],
})
export class SharedExtensionsModule {}
